function setLabel(labelEl: HTMLElement, isOpen: boolean) {
  labelEl.textContent = isOpen ? 'HIDE SCRIPTURE' : 'SHOW SCRIPTURE'
}

export function scriptureToggleInit(): void {
  const toggleBtn = document.getElementById('scripture-toggle-btn') as HTMLButtonElement | null
  const target = document.getElementById('scripture-collapse') as HTMLElement | null
  const label = toggleBtn?.querySelector('.scripture-toggle__label') as HTMLElement | null

  if (!toggleBtn || !target || !label) return

  setLabel(label, target.classList.contains('show'))

  toggleBtn.addEventListener('click', () => {
    const isOpen = target.classList.contains('show')
    setLabel(label, !isOpen)
  })

  target.addEventListener('shown.bs.collapse', (e) => {
    if (e.target === target) setLabel(label, true)
  })
  target.addEventListener('hidden.bs.collapse', (e) => {
    if (e.target === target) setLabel(label, false)
  })
}

document.addEventListener('DOMContentLoaded', () => scriptureToggleInit())
